<template>
  <div class="home">
    <h1 class="header">Dashboard</h1>

    <div class="container">
      <chart :chart-data="datacollection" ref="myChart"></chart>
      <div class="form">
        <dropdown
            class="vue-dropdown"
            :options="strategies"
            :selected="{name: 'Default'}"
            v-model="strategyA"
            v-on:updateOption="updateStratA"
            :placeholder="'Repayment Strategy'"
          ></dropdown>
        <div class="monthly1 input-container">
          <input
            v-model="monthly_payment"
            id="monthly1"
            class="input"
            type="number"
            pattern=".+"
            required
          />
          <label class="label" for="monthly1">Monthly Payment Options</label>
          <input
            v-model="alt_monthly_payment"
            id="monthly2"
            class="input"
            type="number"
            pattern=".+"
            required
          />
          <label class="label" for="monthly2"></label>
        
        </div>
        <button class="calculate" @click="addMonthlyPayment">Calculate</button>
        <!-- <button class="trigger" @click="triggerHover(10)">Trigger</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Chart from "./../LineChart.js";
import moment from "moment";
import dropdown from "vue-dropdowns";
import annotation from "chartjs-plugin-annotation";


export default {
  name: "home",
  components: {
    Chart,
    dropdown
  },
  created() {
    // Chart.plugins.register(annotation);
    if (firebase.auth().currentUser.uid == "T4mry1FFWYXeCgwIr9pTlP0ocTu1") {
      this.loans = [
        {
          balance: 10000,
          interest_rate: 10,
          min_payment: 50
        },
        {
          balance: 5000,
          interest_rate: 5,
          min_payment: 25
        },
        {
          balance: 8000,
          interest_rate: 20,
          min_payment: 40
        }
      ];
    } else {
      this.loans = [];
    }
  },
  data() {
    return {
      value: 0,
      strategies: [{name: 'Avalanche'}, {name:'Snowball'}, {name:'Default'}],
      strategyA: '',
      // strategyB: '',
      datacollection: null,
      datapoints: [],
      monthly_payment: 500,
      alt_monthly_payment: 750,
      monthlypayment_list: [],
      // following loans array is prepopulated with more loans because PLAID sandbox only provides 1 which isn't as interesting
      loans: []
    };
  },
  props: ["api"],
  mounted() {
    this.callScheduler();
  },
  methods: {
    updateStratA(payload) {
      this.strategyA = payload.name;
    },
    // updateStratB(payload) {
    //   this.strategyB = payload.name;
    // },
    random_rgb() {
      var o = Math.round,
        r = Math.random,
        s = 255;
      return [o(r() * s), o(r() * s), o(r() * s)];
    },
    triggerHover(idx) {
      var meta = this.$refs.myChart.getDatasetMeta(0),
        rect = this.$refs.myChart.canvas.getBoundingClientRect(),
        point = meta.data[idx].getCenterPoint(),
        evt = new MouseEvent("mousemove", {
          clientX: rect.left + point.x,
          clientY: rect.top + point.y
        }),
        node = this.$refs.myChart.canvas;
      node.dispatchEvent(evt);
    },
    addMonthlyPayment() {
      this.monthlypayment_list = [];
      if (this.alt_monthly_payment) {
        this.monthlypayment_list.push(this.alt_monthly_payment);
      }
      if (this.monthly_payment) {
        this.monthlypayment_list.push(this.monthly_payment);
      }
      let newDataPoints = [];
      this.monthlypayment_list.map(m => {
        let rgb = this.random_rgb();
        let hex1 = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, .9)`
        let hex2 = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.3)`
        var schedule = this.getPaymentSchedule(
            this.loans,
            m,
            this.strategyA
          );
        newDataPoints.push({
          // plugins: [chartjsPluginAnnotation],
          label: `Remaining Balance for ${m}`,
          data: schedule.map(function(e) {
            return {
              x: moment().add(e.month, "M").format("MMM YYYY"),
              y: e.balance.toFixed(2)
            };
          }),
          backgroundColor: hex1,
          borderColor: hex1,
          borderWidth: 1,
          pointBackgroundColor: hex1,
          pointBorderColor: hex1,
          pointRadius: 2.5,
          pointHoverRadius: 7.5,
          fill: false,
          tension: 0,
          showLine: true
        });

        newDataPoints.push({
          // plugins: [chartjsPluginAnnotation],
          label: `Payments Made for ${m}`,
          data: schedule.map(function(e) {
            return {
              x: moment().add(e.month, "M").format("MMM YYYY"),
              y: e.payments_made.toFixed(2)
            };
          }),
          backgroundColor: hex2,
          borderColor: hex2,
          borderWidth: 1,
          pointBackgroundColor: hex2,
          pointBorderColor: hex2,
          pointRadius: 2.5,
          pointHoverRadius: 7.5,
          fill: false,
          tension: 0,
          showLine: true
        });
      });
      this.datapoints = newDataPoints;
      this.datacollection = {
        datasets: this.datapoints
      };
    },
    callScheduler() {
      // console.log(this.$props.api.response);
      this.$props.api.response.map(d => {
        let student;
        for (student of d.liabilities.student) {
          let account = d.accounts.find(
            e => e.account_id == student.account_id
          );
          this.loans.push({
            balance: account.balances.current,
            interest_rate: student.interest_rate_percentage,
            min_payment: student.minimum_payment_amount
          });
        }
      });
    },
    getPaymentSchedule(loans, monthly_payment, method) {
      //Loans = [{balance,interest_rate, min_payment}, ...]
      var temp_loans = JSON.parse(JSON.stringify(loans));
      switch (method) {
        case 'Avalanche':
          temp_loans.sort((a, b) => b.interest_rate - a.interest_rate);
          break;
        case 'Snowball':
          temp_loans.sort((a, b) => a.balance - b.balance);
          break;  
        default:
          temp_loans.sort((a, b) => a.interest_rate - b.interest_rate);
      }
      
      var total_balance = 0;
      for (var i = 0; i < temp_loans.length; i++) {
        total_balance += loans[i].balance;
      }
      var schedule = [];
      var month = 0;
      var remaining_balance = total_balance;
      var payment_made = 0;
      schedule.push({
        month: month,
        balance: remaining_balance,
        payments_made: payment_made
      });
      var current_loan = 0;
      while (remaining_balance > 0) {
        month++;
        var totalInterest = 0;
        var discretionary_payment = monthly_payment;
        for (var i = 0; i < temp_loans.length; i++) {
          var monthly_interest_rate = temp_loans[i].interest_rate / 100 / 12;
          var monthly_interest = monthly_interest_rate * temp_loans[i].balance;
          totalInterest += monthly_interest;
          if (totalInterest > monthly_payment) {
            alert("Interest exceeds monthly payment");
            return;
          }
          temp_loans[i].balance += monthly_interest;
          if (temp_loans[i].min_payment >= temp_loans[i].balance) {
            temp_loans[i].balance = 0;
            temp_loans[i].min_payment = 0;
            payment_made += temp_loans[i].balance;
            discretionary_payment -= temp_loans[i].balance;
          } else {
            temp_loans[i].balance -= temp_loans[i].min_payment;
            payment_made += temp_loans[i].min_payment;
            discretionary_payment -= temp_loans[i].min_payment;
          }
        }
        while (discretionary_payment > 0) {
          if (temp_loans[current_loan].balance < discretionary_payment) {
            discretionary_payment -= temp_loans[current_loan].balance;
            payment_made += temp_loans[current_loan].balance;
            temp_loans[current_loan].balance = 0;
            temp_loans[current_loan].min_payment = 0;
            current_loan++;
            if (current_loan >= temp_loans.length) {
              break;
            }
          } else {
            temp_loans[current_loan].balance -= discretionary_payment;
            payment_made += discretionary_payment;
            discretionary_payment = 0;
          }
        }
        remaining_balance = 0;
        for (var i = 0; i < temp_loans.length; i++) {
          remaining_balance += temp_loans[i].balance;
        }
        schedule.push({
          month: month,
          balance: remaining_balance,
          payments_made: payment_made
        });
      }
      return schedule;
    }
  }
};
</script>

<style scoped lang="scss">
.home {
  margin-bottom: 3rem;

  .container {
    .form {
      display: flex;
      flex-direction: column;
      width: 67%;
      margin: auto;
      text-align: center;

      .input-container{
        display: flex;
        padding: 0rem 0 3rem 0;
        margin-top: 2rem;

        #monthly1{
          margin-right: 15px;
        }
      }

      .monthly2 {
        margin: 3rem 0;
      }

      .number {
        margin: 2rem 0;
      }
      .calculate {
        margin-top: -1rem !important;
      }
    }
  }

  .header {
    font-family: var(--sans);
    padding: 0 2rem;
  }
}

.vue-dropdown {
  font-family: var(--sans);
  width: 50%;
  min-width: unset;

  .dropdown-toggle{
    min-width: unset !important;
    width: 5rem !important;
  }
}
</style>